import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@tools-beaver/shared';
import { AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY } from '@tools-beaver/shared';

interface AppState {
  user: User | null;
  isAuthModalOpen: boolean;
  authModalMode: 'login' | 'register';
  pendingAction: string | null;

  setUser: (user: User | null) => void;
  openAuthModal: (mode?: 'login' | 'register', pendingAction?: string) => void;
  closeAuthModal: () => void;
  logout: () => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      user: null,
      isAuthModalOpen: false,
      authModalMode: 'register',
      pendingAction: null,

      setUser: (user) => set({ user }),

      openAuthModal: (mode = 'register', pendingAction) =>
        set({ isAuthModalOpen: true, authModalMode: mode, pendingAction: pendingAction ?? null }),

      closeAuthModal: () =>
        set({ isAuthModalOpen: false, pendingAction: null }),

      logout: () => {
        localStorage.removeItem(AUTH_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        set({ user: null });
      },
    }),
    {
      name: 'tb-app-store',
      partialize: (state) => ({ user: state.user }),
    }
  )
);
